import { Dispatch } from "@reduxjs/toolkit";
import { NavigateFunction } from "react-router-dom";
import { checkoutActions } from "@dashboard/modules/checkout/store/checkout.slice";
import { DeliveryDetails } from "../entities/delivery.entities";
import { fetchDeliveryDetails } from "../fetchers/logistic.fetchers";

export type LogisticCheckoutPrep = {
  logisticOrderId: number;
  orderPaymentId: number;
  total: number;
  providerName: string;
};

export const prepareLogisticCheckoutFromDetail = (
  detail: DeliveryDetails,
  orderId: number
): LogisticCheckoutPrep => ({
  logisticOrderId: detail.orderId ?? orderId,
  orderPaymentId:
    detail.orderLogisticPayment?.orderPaymentId ?? orderId,
  total: detail.totalValue ?? 0,
  providerName: detail.provider ?? "",
});

export const prepareLogisticCheckout = async (
  token: string,
  orderId: number
): Promise<LogisticCheckoutPrep> => {
  const detail = await fetchDeliveryDetails(token, orderId);
  return prepareLogisticCheckoutFromDetail(detail, orderId);
};

export const navigateToLogisticPayment = (
  dispatch: Dispatch,
  navigate: NavigateFunction,
  userId: string,
  prep: LogisticCheckoutPrep
) => {
  dispatch(
    checkoutActions.setToBuyItem({
      type: "logistic",
      order_id: prep.logisticOrderId,
    })
  );
  dispatch(checkoutActions.setOrderId(prep.orderPaymentId));
  navigate(`/${userId}/checkout`);
};
